module.exports = __webpack_public_path__ + "img/full3-min.99d2cb52.png";